export default {
    name: 'QModal',
    props: {
        id: {
            type: String,
            default: 'q-modal'
        },
        size: {
            type: String,
            default: 'modal-medium'
        },
        canClose: {
            type: Boolean,
            default: true
        }
    },
    created() {
        document.body.addEventListener('keydown', e => {
            if (e.keyCode === 27) {
                this.$emit('close');
            }
        });
    }
};
